import MediaQueryService from "Services/MediaQueryService";

import config from "../../js/config";

export default function template() {
  return `
<span class="fra-js-debug-layer__mq-info">${window.innerWidth} × ${window.innerHeight} -- ${
    MediaQueryService.currentMQ
  }</span>
<input class="fra-e-debug-layer__input" type="checkbox" title="Show Grid">
<div class="fra-e-debug-layer__container">
  <div class="fra-grid">
    <div class="fra-grid-row">
      ${Array(12).fill('<div class="fra-grid-col-mq1-1"></div>').join("\n")}
    </div>
  </div>
</div>
<input class="fra-e-debug-layer__input" type="checkbox" title="Show Breakpoints">
<div class="fra-e-debug-layer__container">

  ${config.mediaQueries
    // ne need fo MQ5 which has no max width
    .slice(0, -1)
    .map(
      mq =>
        `<div class="fra-e-debug-layer__mq" style="width: ${mq.max}px">(${mq.min}-${mq.max}px) ${mq.mediaQuery}</div>`,
    )
    .join("\n")}
</div>
<input class="fra-e-debug-layer__show-outlines fra-js-debug-layer__show-outlines" type="checkbox" title="Show elements outlines">
<fra-e-icon class="fra-e-icon fra-js-debug-layer__minimize fra-e-debug-layer__minimize" icon-id="fra-icon-chevron-left"></fra-e-icon>
  `;
}
